/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Modal, Icon } from '@mairistem/composants';

interface AssistantModalErrorCreationProps {
  numero?: string | null;
  onClose: () => void;
}

const AssistantModalErrorCreation = (
  props: AssistantModalErrorCreationProps,
) => {
  const { numero, onClose } = props;

  return (
    <Modal
      open
      closeIcon
      onClose={onClose}
      size="tiny"
      data-testid="assistant-modal-error-creation"
    >
      <Modal.Header>Erreur de création</Modal.Header>
      <Modal.Content style={{ textAlign: 'center' }}>
        <Icon
          size="large"
          name="warning sign"
          color="red"
          style={{ marginBottom: '1rem' }}
        />
        <p>
          Le numéro <b>{numero}</b> est déjà attribué, il sera donc mis à jour
          au prochain numéro disponible.
        </p>
      </Modal.Content>
    </Modal>
  );
};

export default AssistantModalErrorCreation;
